const transforms = {
    stringToNull(value) {
        return value && value.length > 0 ? value : null;
    }
}

export default transforms;